import { Phone, DollarSign } from "lucide-react";
import { Button } from "@/components/ui/button";
import { NavLink } from "@/components/NavLink";

export const StickyMobileCTA = () => {
  const handleGetStartedClick = () => {
    const formSection = document.getElementById("get-started");
    if (formSection) {
      formSection.scrollIntoView({ behavior: "smooth" });
    } else {
      // Fallback to contact page if no #get-started anchor
      window.location.href = "/contact#get-started";
    }
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-background/95 backdrop-blur-md border-t shadow-lg safe-area-bottom">
      <div className="flex items-center gap-2 p-3 pb-[calc(0.75rem+env(safe-area-inset-bottom,0px))]">
        <Button 
          onClick={handleGetStartedClick}
          className="flex-1 gap-2"
          size="lg"
        >
          <Phone className="h-4 w-4" />
          Get Started
        </Button>
        <NavLink to="/websites/" className="flex-1">
          <Button 
            variant="outline" 
            className="w-full gap-2"
            size="lg"
          >
            <DollarSign className="h-4 w-4" />
            Pricing
          </Button>
        </NavLink>
      </div>
    </div>
  );
};
